document.querySelectorAll('.quick-buy__rail').forEach(function (rail) {
  var wrapper = rail.closest('slider-component');
  if (!wrapper) return;

  var dots = wrapper.querySelectorAll('.quick-buy__dot');
  if (!dots.length) return;

  var slides = rail.children;

  function setActive(index) {
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  function sync() {
    var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
    if (atEnd) {
      setActive(dots.length - 1);
      return;
    }

    var closestIndex = 0;
    var closestDistance = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var distance = Math.abs(slides[i].offsetLeft - rail.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    }
    setActive(closestIndex);
  }

  rail.addEventListener(
    'scroll',
    function () {
      window.requestAnimationFrame(sync);
    },
    { passive: true }
  );
});

document.querySelectorAll('.quick-buy-card__form').forEach(function (form) {
  var idInput = form.querySelector('input[name="id"]');
  var qtyInput = form.querySelector('input[name="quantity"]');
  var returnToInput = form.querySelector('input[name="return_to"]');
  if (!idInput) {
    return;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
    }

    var quantity = (qtyInput && Number.parseInt(qtyInput.value, 10)) || 1;

    // Adds first and prunes the rest of the cart second, so a failed add
    // leaves the customer's cart as it was (see replaceCartWith in global.js).
    replaceCartWith(form.action + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: idInput.value, quantity: quantity }],
        attributes: { Source: 'Quick buy' },
      }),
    })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (error) {
        if (submitButton) {
          submitButton.disabled = false;
        }

        // The plan is already in the cart next to the old items: let the
        // customer review it there (a native resubmit would add it twice).
        if (checkIsCartPruneError(error)) {
          window.location.href = window.routes.cart_url;
          return;
        }

        // Nothing was added (rejected, or a Cloudflare challenge fetch() can't
        // solve). Retry natively, landing on the cart rather than checkout,
        // since the old items are still in it.
        if (returnToInput) {
          returnToInput.value = '/cart';
        }
        form.submit();
      });
  });
});

// Re-enable "Get connected" buttons left disabled from a prior submit when
// the page is restored from the browser's back/forward cache (bfcache) -
// otherwise the button stays permanently disabled after hitting back.
window.addEventListener('pageshow', function () {
  document.querySelectorAll('.quick-buy-card__cta').forEach(function (button) {
    button.disabled = false;
  });
});